import { CONTENT_HEADING } from "../../constants";
import Content from "../global/Content";
import { useNavigate,Link } from "react-router-dom";

const Seo = () => {
	const navigate = useNavigate();
	const handleRedirect = (e, path = "/registration") => {
		e.preventDefault();
		window.scroll({ top: 0, behavior: "smooth" });
		navigate(path);
	  };
  const token = localStorage.getItem("usertoken");
	return (
		
		<Content title={CONTENT_HEADING.SEO}>
			<p className='pera-text tagp'>
				There are many ways to maximize your article’s discoverability
				and search results.
			</p>

			<p className='pera-text tagp'>
				<strong>Keywords: </strong>Identify relevant keywords and
				phrases that are commonly used by your target audience when
				searching for content related to your research. Remember to
				include a few of your article’s keywords in the title of the
				article and in the article itself.
			</p>

			<p className='pera-text tagp'>
				Use tools like Google Keyword Planner, SEMrush, or Moz Keyword
				Explorer to find popular and relevant keywords.
			</p>

			<p className='pera-text tagp'>
				You can use the following strategies to use keywords to your
				maximum benefit:
			</p>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				>
					PRIMARY KEYWORD PLACEMENT:{" "}
				</strong>
				Select one or two primary keywords that accurately represent the
				main focus of your article. Place these keyword strategically in
				the following elements:
			</p>

			<ul className="tagul">
        <li className="tagli">
					<strong>Article title: </strong>Include your primary
					keywords in the title, preferably towards the beginning.
				</li>
				<li className="tagli">
					<strong>Meta tags: </strong>Optimize the Meta title and Meta
					description of your article by incorporating the primary
					keyword. This helps search engines understand the relevance
					of your content.
				</li>
				<li className="tagli">
					<strong>Introduction: </strong>Introduce your primary
					keyword naturally in the opening paragraph of your article.
					This signals to search engines and readers that your content
					is relevant to their search.
				</li>
				<li className="tagli">
					<strong>Keyword integration in content: </strong>
					Throughout the body of your article, incorporate your
					primary keyword and related keywords in a natural and
					meaningful way. Avoid keyword stuffing, which is the
					excessive and unnatural use of keywords, as it can harm your
					SEO efforts. Instead, focus on these areas:
				</li>
				<li className="tagli">
					<strong>Headings and subheadings: </strong>
					Include relevant keywords in your headings and subheadings
					to improve the organization and readability of your article.
					This helps search engines understand the structure of your
					content.{" "}
				</li>
				<li className="tagli">
					<strong>Body Paragraphs: </strong>Integrate keywords into
					your sentences and paragraphs naturally. Aim for a smooth
					flow of content while ensuring keyword relevance.
				</li>
				<li className="tagli">
					<strong>Conclusion: </strong>Consider including your primary
					keyword in the conclusion section to reinforce its
					importance and relevance.{" "}
				</li>
				<li className="tagli">
					<strong>Long-tail keywords: </strong>Long-tail keywords are
					more specific and longer phrases that are highly targeted.
					They often have lower search volume but can attract more
					qualified traffic. Incorporate long-tail keywords naturally
					in your content, especially in subheadings and throughout
					the body of your article.{" "}
				</li>
				<li className="tagli">
					<strong>Synonyms and variations: </strong>Use synonyms,
					related terms, and variations of your primary keyword
					throughout your article. This helps search engines
					understand the different aspects and contexts of your
					content. It also provides more opportunities for your
					article to appear in relevant search queries.
				</li>
				<li className="tagli">
					<strong>Headers and Formatting: </strong>We have simplified
					the submission process by breaking the article into relevant
					sections. Each section has a section header (Title,
					Introduction, Abstract etc). Barring a few mandatory headers
					such as Introduction, Abstract, Conclusion, all other
					headers are customisable. You need to merely to click on the
					Section Header and type in your own customized heading.
				</li>
				<li className="tagli">
					<strong>Alt tags for images: </strong>We have simplified the
					process of uploading images. Out AI driven platform will
					automatically assign an image number and prompt you to
					provide the image caption. The same process is performed
					when you submit a Table. This not only helps search engines
					understand the content of your images but also improves
					their visibility in image searches.
				</li>
			</ul>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				>
					TITLE OF THE ARTICLE:{" "}
				</strong>
				The title of your research article plays a crucial role in
				attracting readers and improving search engine optimization
				(SEO). Here are some tips on how to smartly use the title to
				maximize its benefits:
			</p>

			<ul className="tagul">
        <li className="tagli">
					<strong>Optimize the article title: </strong>Do not use long
					article titles. Craft a compelling title including your
					primary keyword. Ensure the title encourages users to click
					on it in search results.
				</li>
				<li className="tagli">
					<strong>Write high-quality content: </strong>
					Focus on addressing the topic comprehensively, incorporating
					relevantkeywords naturally throughout the article.{" "}
				</li>
				<li className="tagli">
					<strong>Focus on the main idea: </strong>Ensure that your
					title captures the central idea or the most significant
					findings of your research.{" "}
				</li>
				<li className="tagli">
					<strong>Use active and engaging language: </strong>
					Opt for active verbs and engaging language that piques
					theinterest of potential readers and encourages users to
					click on it in search results.{" "}
				</li>
			</ul>

			<p className='pera-text'>
				Avoid jargon or technical terms: Opt for language that is
				accessible to a broader audience, including researchers outside
				your specific field.
			</p>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				>
					OPTIMIZE META TAGS:{" "}
				</strong>
				Pay attention to the title and description of your article.
				These are the snippets that appear in search engine results
				pages (SERPs). Include your primary keyword in the Meta title
				and craft a compelling Meta description that entices users to
				click on your article.
			</p>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				>OPTIMIZE IMAGES: </strong>
				Include relevant images in your article and optimize them for
				SEO. Use descriptive file names and alt tags that include
				relevant keywords. This helps search engines understand the
				content of your images and improves their visibility in image
				searches.
			</p>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				 >
					INTERNAL AND EXTERNAL LINKING:{" "}
				</strong>
				Incorporate links within your article carefully to relevant
				pages of other credible websites. This helps search engines
				understand the context and hierarchy of your content.
			</p>

			<p className='pera-text tagp'>
				<strong className="customseoprimary"
				>
					PROMOTE YOUR ARTICLE:{" "}
				</strong>
				Share your article on social media platforms, relevant forums,
				and professional networks. Encourage others to link to your
				article, and engage with your audience to increase visibility
				and attract organic traffic.
			</p>

			<p className='pera-text tagp'>
			<Link to="https://www.crossref.org/" target="_blank" className='underline blackbold'>
					Cross Mark Policy{" "}
				</Link>
			</p>

			<p className='pera-text tagp'>
				<Link to='https://www.crossref.org/documentation/crossmark/crossmark-policy-page/' target="_blank"  className='underline blackbold'>
					Cross Mark Policy Doc{" "}
				</Link>
			</p>

			<p className='pera-text tagp'>
				CrossMark is a multi-publisher initiative to provide a standard
				way for readers to locate the current version of a piece of
				content. By applying the CrossMark logo Aakashganga is committed
				to maintaining the content it publishes and to alerting readers
				to changes if and when they occur.{" "}
			</p>

			<p className='pera-text tagp'>
				Clicking on the CrossMark logo will tell you the current status
				of a document and may also give you additional publication
				record information about the document.
			</p>
		</Content>
	 
	);
};

export default Seo;
